import GeneralNotice from '@pelckmans/elementis/components/general-notice';

export type LoadingText = { title: string; p1: string; p2: string };

export function ExerciseLoading({ loadingText }: { loadingText: LoadingText }) {
  const { REACT_APP_P_STUDIO_GROUP } = process.env;

  return (
    <GeneralNotice
      className="exercise-general-notice"
      data-testid="exercise-loading"
      logoProps={{
        variant: REACT_APP_P_STUDIO_GROUP,
        'aria-label': 'logo',
      }}
      text={loadingText.title}
      subText={
        <>
          {loadingText.p1}
          <br />
          {loadingText.p2}
        </>
      }
      spinner
    />
  );
}
